import React from 'react'
import {
  AddOrEditAddressButton,
  EditAddressButtons,
} from '../EditAddressButton'
import { AddressesProps, useAddressesModel } from './useAddressesModel'

export const Addresses: React.FC<AddressesProps> = props => {
  const model = useAddressesModel(props)
  const changedAddressMessage = model.shouldShowAddressChangedMessage && (
    <p className="typography-body-xs text-text-subdued sale-fulfilment-delivery-hint">
      {model.changedAddressMessage}
    </p>
  )

  return (
    <div className="uc-base">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          {model.hasBillingAddressAndNoShippingAddressInModal ? (
            <>
              <p className="typography-body-sm-emphasized">
                {model.noShippingAddressModalTitle}
              </p>
              <p className="typography-body-sm">
                {model.noShippingAddressModalDescription}
              </p>
            </>
          ) : (
            <div className="flex items-start justify-between gap-3">
              <div className="flex min-w-0 flex-col gap-1">
                <p className="typography-body-sm-emphasized">
                  {model.shippingAddressTitle}
                </p>
                <p className="typography-body-sm whitespace-pre-line">
                  {props.formattedShippingAddress}
                </p>
                {!model.shouldShowBillingAddress && changedAddressMessage}
              </div>
              <AddOrEditAddressButton
                type={EditAddressButtons.edit}
                hasError={props.hasError}
                isModalOpeningOnError={props.isModalOpeningOnError}
                fulfilmentDetail={props.fulfilmentDetail}
                onSave={props.onSave}
                lineItemLocalId={props.lineItemLocalId}
                onOpenModal={model.openAddressModal}
              />
            </div>
          )}
        </div>
        {model.shouldShowBillingAddress && (
          <div className="flex flex-col gap-1">
            <p className="typography-body-sm-emphasized">
              {model.billingAddressTitle}
            </p>
            <p className="typography-body-sm whitespace-pre-line">
              {props.formattedBillingAddress ?? ''}
            </p>
            {changedAddressMessage}
          </div>
        )}
      </div>
    </div>
  )
}
